/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const CancelScheduleSiteChangeRequest = zod.object({
  "id": zod.string().uuid()
});

export type CancelScheduleSiteChangeRequest = zod.input<typeof CancelScheduleSiteChangeRequest>;
export type CancelScheduleSiteChangeRequestOutput = zod.output<typeof CancelScheduleSiteChangeRequest>;
